module.exports = __webpack_public_path__ + "img/report-icon.0a087de3.svg";